webpackJsonp([627],{

/***/ 1014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": "1px 解决方案 | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 1968:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1014),
  /* template */
  __webpack_require__(2460),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/1px-157.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] 1px-157.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0a352067", Component.options)
  } else {
    hotAPI.reload("data-v-0a352067", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2460:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("1px 解决方案")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("1px 方案在 VUX 组件内应用广泛，包括 "), _c('code', [_vm._v("Grid")]), _vm._v(", "), _c('code', [_vm._v("ButtonTab")]), _vm._v(", "), _c('code', [_vm._v("XTable")]), _vm._v(", "), _c('code', [_vm._v("XButton")]), _vm._v(", "), _c('code', [_vm._v("Cell")]), _vm._v(" 等等。")]), _vm._v(" "), _c('p', [_vm._v("利用 "), _c('code', [_vm._v("Flexbox")]), _vm._v(" + "), _c('code', [_vm._v("1px")]), _vm._v(" 你可以实现复杂的宫格布局。")])]), _vm._v(" "), _c('h2', [_vm._v("引入")]), _vm._v(" "), _c('p', [_vm._v("在你项目的"), _c('code', [_vm._v("App.vue")]), _vm._v("引入，组件内不需要再重复引入。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("lang")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"less\"")]), _vm._v(">")]), _c('span', {
    staticClass: "undefined"
  }, [_vm._v("\n@import '~vux/src/styles/1px.less';\n")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("style")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('h2', [_vm._v("可用类名：")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("vux-1px-l")]), _vm._v(" 左边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-r")]), _vm._v(" 右边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-t")]), _vm._v(" 上边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-b")]), _vm._v(" 下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px-tb")]), _vm._v(" 上下边框")]), _vm._v(" "), _c('li', [_c('code', [_vm._v("vux-1px")]), _vm._v(" 全边框")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0a352067", module.exports)
  }
}

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1968);

/***/ })

});


// WEBPACK FOOTER //
// 627.96d7080a.js